import Api from "@/lib/axios";

const ProviderRatesService = {
  createProviderRate (params) {
    return Api.post("/api/autopricing/partners/payout/rates", params);
  },

  updateProviderRate (params) {
    return Api.post("/api/autopricing/partners/payout/rates", params);
  },

  deleteProviderRate (params) {
    return Api.delete(`/api/autopricing/partners/payout/rates/${ params.id }`);
  },

  async getPartners () {
    const response = await Api.get("/api/autopricing/partners")
      .then((res) => {
        return res.data;
      });

    const data = response.filter((item) => {
      return item.enabled;
    });

    return data;
  },

  async getProviderRates (payload) {
    const data = {
      ...payload,
      page: (payload.page || 1) - 1
    };

    const response = await Api.get("/api/autopricing/partners/payout/rates", {
      data
    });

    const list = response?.data?.content || [];
    const pagination = response?.data?.pageable || {};

    return {
      list,
      pagination: {
        ...pagination,
        totalElements: response?.data?.totalElements,
        totalPages: response?.data?.totalPages
      }
    };
  }
}

export default ProviderRatesService;
